<template>
<SortMe :options="sorts" @sort="sort"/>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { sorts } from './fields'

export default {
    name: 'SortIt',

    data() {
        return {
            sorts
        }
    },

    computed: {
        ...mapGetters({
            filterMeFields: 'filterMeComponent/filterMeFields'
        }),
    },

    methods: {
        ...mapActions({
            setParams: 'commission/setParams',
            fetch: 'commission/fetch'
        }),
        sort(val) {
            this.setParams({
                page: 1,
                sorter: val
            })
            this.fetch({
                ...this.filterMeFields
            })
        }
    }
}
</script>